import React, { useCallback, useState } from 'react';
import TrueImpactTextIndicator from 'shared/design-system/components/TrueImpactTextIndicator';
import DonorNameHighlight from 'npo/pages/ReportsBeta/LevelOneFeedback/DonorNameHighlight';

interface IndicatorTextareaRenderProps {
  id: string | number;
  initialValue?: string;
  disabled?: boolean;
  handleSave: (text: string) => unknown;
  placeholder?: string;
  textareaClassName?: string;
  maxLength?: number;
  questionId?: number;
}

let onChangeTimeout: NodeJS.Timeout | undefined = undefined;
const IndicatorTextareaRender: React.FC<IndicatorTextareaRenderProps> = ({
  id,
  disabled,
  handleSave,
  initialValue = '',
  placeholder,
  textareaClassName,
  maxLength,
  questionId,
}) => {
  const [text, setText] = useState<string>(initialValue);

  const handleUpdateText = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      clearTimeout(onChangeTimeout);
      const { value } = e.target;
      setText(value);
      onChangeTimeout = setTimeout(() => handleSave(value), 2000);
    },
    [setText, handleSave],
  );

  const handleBlur = useCallback(() => {
    if (initialValue === text) return;
    handleSave(text);
  }, [text, initialValue, handleSave]);

  const handleClear = useCallback(() => {
    setText('');
    handleSave('');
  }, [handleSave]);

  return (
    <>
      <DonorNameHighlight text={text} questionId={questionId}>
        <textarea
          key={id}
          id={id.toString()}
          disabled={disabled}
          onBlur={handleBlur}
          onChange={handleUpdateText}
          value={text}
          maxLength={maxLength || 250}
          defaultValue={initialValue}
          placeholder={placeholder}
          className={textareaClassName}
        />
      </DonorNameHighlight>
      <TrueImpactTextIndicator
        text={text}
        minLength={0}
        maxLength={maxLength || 250}
        handleClear={handleClear}
      />
    </>
  );
};

export default IndicatorTextareaRender;
